
enum CompetitorType {
	HOTEL='HOTEL', GROUP='GROUP'
}

export default CompetitorType;